import { UpgradePlanSelection} from "@components/UpgradePlanSelection"


export const UpgradeSubscriptionPage = () => {

  return (
    <UpgradePlanSelection/>  
  )
}
